import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGit = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-git';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.46 6.48.94 12l5.53 5.53L12 23.06l5.53-5.53L23.06 12l-5.52-5.52C14.504 3.444 12.011.96 12 .96S9.496 3.444 6.46 6.48m10.02 1.06L20.94 12l-4.47 4.47L12 20.94l-4.47-4.47L3.06 12l2.87-2.87L8.8 6.26l1.22 1.22 1.22 1.22v6.432l-.158.136a1.4 1.4 0 0 0-.29.403c-.116.235-.132.306-.132.588 0 .409.13.713.425.989.666.626 1.751.409 2.143-.428.093-.2.112-.293.112-.561 0-.282-.016-.353-.132-.588a1.4 1.4 0 0 0-.29-.403l-.158-.136v-4.951l.771.77.771.77.002.29a1.34 1.34 0 0 0 1.455 1.338c.468-.042.901-.34 1.121-.773.086-.168.1-.25.1-.576 0-.448-.083-.656-.38-.953a1.23 1.23 0 0 0-.924-.384l-.309-.003-2.753-2.727L9.86 5.206l1.06-1.063A41 41 0 0 1 12 3.08c.011 0 2.027 2.007 4.48 4.46"
    })
  }));
});
export default SvgGit;